import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["previous", "next"];
  static values = { swipeThreshold: { type: Number, default: 50 } };

  previous(event) {
    if (this.insideVideo(event)) return;

    if (this.hasPreviousTarget) this.previousTarget.click();
  }

  next(event) {
    if (this.insideVideo(event)) return;

    if (this.hasNextTarget) this.nextTarget.click();
  }

  startSwipe(event) {
    this.swipeOrigin = this.insideVideo(event) ? null : event.changedTouches[0];
  }

  endSwipe(event) {
    if (!this.swipeOrigin) return;

    const touch = event.changedTouches[0];
    const horizontal = touch.clientX - this.swipeOrigin.clientX;
    const vertical = touch.clientY - this.swipeOrigin.clientY;
    this.swipeOrigin = null;

    if (Math.abs(horizontal) < this.swipeThresholdValue) return;
    if (Math.abs(horizontal) < Math.abs(vertical)) return;

    horizontal < 0 ? this.next(event) : this.previous(event);
  }

  insideVideo(event) {
    return event.target.closest("video") !== null;
  }
}
